'use strict';

module.exports.make = (type, key, question) => {
    return {
        name: key,
        question,
        checkLabel: question,
        label: question,
        fhirType: type,
        jq: [`item[text=? & linkId=${key}].answer[0].${type}`, question]
    };
};

module.exports.makeNoLabel = (type, key, question) => {
    return {
        name: key,
        question,
        fhirType: type,
        jq: [`item[text=? & linkId=${key}].answer[0].${type}`, question]
    };
};
